"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-mango-sul-calore": {
    "3faea5ef": [{
      "hkey": "acb7fd07",
      "slug": "san-mango-sul-calore",
      "name": "San Mango sul Calore",
      "primary": true,
      "skipSearch": false
    }],
    "cesine": [{
      "hkey": "acb7fd07",
      "slug": "san-mango-sul-calore",
      "name": "San Mango sul Calore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dc02c8b4": [{
      "hkey": "acb7fd07",
      "slug": "san-mango-sul-calore",
      "name": "San Mango sul Calore",
      "primary": true,
      "skipSearch": false
    }],
    "malvito": [{
      "hkey": "acb7fd07",
      "slug": "san-mango-sul-calore",
      "name": "San Mango sul Calore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8f99efb6": [{
      "hkey": "acb7fd07",
      "slug": "san-mango-sul-calore",
      "name": "San Mango sul Calore",
      "primary": true,
      "skipSearch": false
    }],
    "pescore": [{
      "hkey": "acb7fd07",
      "slug": "san-mango-sul-calore",
      "name": "San Mango sul Calore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a4aec968": [{
      "hkey": "acb7fd07",
      "slug": "san-mango-sul-calore",
      "name": "San Mango sul Calore",
      "primary": true,
      "skipSearch": false
    }],
    "santo-stefano": [{
      "hkey": "acb7fd07",
      "slug": "san-mango-sul-calore",
      "name": "San Mango sul Calore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "646c152e": [{
      "hkey": "acb7fd07",
      "slug": "san-mango-sul-calore",
      "name": "San Mango sul Calore",
      "primary": true,
      "skipSearch": false
    }],
    "verzari": [{
      "hkey": "acb7fd07",
      "slug": "san-mango-sul-calore",
      "name": "San Mango sul Calore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;